/**
 * Allowlist check for `projects.external_ui_url` redirects.
 *
 * The DB CHECK projects_external_ui_url_fakto_https enforces a regex (`https://*.fakto.ai`), but we
 * ALSO check on the client so a misconfigured row or stale DB write
 * cannot turn a project tile into token exfiltration. Defense in depth.
 *
 * Listed hosts are exact, one per app and environment; adding a
 * per-customer UI means adding its FQDNs here AND in the backend mirror,
 * `lambda/shared/external-ui-allowlist.ts`.
 */
export const ALLOWED_EXTERNAL_UI_HOSTS: ReadonlySet<string> = new Set([
  // nge-fuel
  'nge-fuel.app.fakto.ai',
  'nge-fuel.app-dev.fakto.ai',
  // nge-rental-equipment (project: location-materiel)
  'nge-rental-equipment.app.fakto.ai',
  'nge-rental-equipment.app-dev.fakto.ai',
  // nge-trade (project: negoce)
  'nge-trade.app.fakto.ai',
  'nge-trade.app-dev.fakto.ai',
  // nge-maintenance-and-repair (project: entretien-et-rparation)
  'nge-maintenance-and-repair.app.fakto.ai',
  'nge-maintenance-and-repair.app-dev.fakto.ai',
  // orange-lease — Orange's commercial-lease console (FaktoAI/orange-lease);
  // its webapp project is not created yet
  'orange-lease.app.fakto.ai',
  'orange-lease.app-dev.fakto.ai',
]);

/**
 * Return true iff `url` is an absolute HTTPS URL whose host is in the
 * allowlist. Used to gate the `window.location.assign` in App.tsx.
 *
 * Doesn't throw on malformed input — returns false so the caller can
 * either log + ignore or fall through to the in-app navigation.
 */
export function isAllowedExternalUiUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:') return false;
  return ALLOWED_EXTERNAL_UI_HOSTS.has(parsed.host.toLowerCase());
}
